<template>
  <div class="wineryItemComponentForm">
    <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
    >
      Matični podaci
    </div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <!--<v-layout row wrap>-->
      <!--<v-flex xs8>-->
      <!--<v-text-field-->
      <!--v-model="ID"-->
      <!--label="ID" readonly-->
      <!--&gt;</v-text-field>-->
      <!--</v-flex>-->
      <!--</v-layout> &lt;!&ndash; /.ID &ndash;&gt;-->

      <v-layout row wrap>
        <v-flex xs3 pa-2>
          <v-text-field
            v-model="naziv"
            label="Naziv"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="adresa"
            label="Adresa"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="grad"
            label="Mesto"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs1 pa-2>
          <v-text-field
            v-model="postanski_broj"
            label="Poštanski broj"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            type="number"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="drzava"
            label="Država"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="email"
            label="Email"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Name -->

      <v-layout row wrap>
        <v-flex xs1 pa-2>
          <v-text-field
            v-model="pib"
            label="PIB"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            type="number"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 pa-2>
          <v-text-field
            v-model="maticni_broj"
            label="Matični broj"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            type="number"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="banka"
            label="Banka"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="racun"
            label="Račun"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="fiksni"
            label="Fiksni broj"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="mobilni"
            label="Mobilni broj"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="faks"
            label="Faks"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <v-textarea
            v-model="opis"
            name="input-5-1"
            class="Description"
            label="Opis"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear" class="AppButtonOutlined">odustani</v-btn>
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "WineryItem",
  data: () => ({
    valid: true,
    ID: "0",
    naziv: "",
    adresa: undefined,
    grad: undefined,
    postanski_broj: undefined,
    drzava: undefined,
    email: undefined,
    pib: undefined,
    maticni_broj: undefined,
    banka: undefined,
    racun: undefined,
    fiksni: undefined,
    mobilni: undefined,
    faks: undefined,
    opis: "",
  }),
  components: {
    TokenComponent,
  },
  methods: {
    newSifarnik() {
      var complexObject = {
        name: this.naziv,
        identityNumber: this.maticni_broj,
        taxNumber: this.pib,
        country: this.drzava,
        city: this.grad,
        address: this.adresa,
        phone: this.fiksni,
        mobile: this.mobilni,
        fax: this.faks,
        email: this.email,
        bankAccount: this.racun,
        bankName: this.banka,
        description: this.opis,
        postalCode: this.postanski_broj
      };

      //// // console.log(complexObject);

      this.$http
        .post(
          this.globalServiceLocation + this.globalPort + "/winery_data",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          serverBus.$emit("refresh_winery");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/winery_data",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      serverBus.$emit("refresh_winery");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      var complexObject = {
        id: this.ID,
        name: this.naziv,
        identityNumber: this.maticni_broj,
        taxNumber: this.pib,
        country: this.drzava,
        city: this.grad,
        address: this.adresa,
        phone: this.fiksni,
        mobile: this.mobilni,
        fax: this.faks,
        email: this.email,
        bankAccount: this.racun,
        bankName: this.banka,
        description: this.opis,
        postalCode: this.postanski_broj
      };

      this.$http
        .put(
          this.globalServiceLocation + this.globalPort + "/winery_data",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          serverBus.$emit("refresh_winery");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation + this.globalPort + "/winery_data",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      serverBus.$emit("refresh_winery");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.ID != "" && this.ID != "0") {
          this.changeSifarnik();
        } else {
          this.newSifarnik();
        }

        this.clear();
      }
    },
    clear() {
      this.$refs.form.reset();
      this.ID = 0;
    },
  },
  mounted() {
    this.clear();

    serverBus.$on("applied_winery", (item) => {
      //alert(item.name);
      this.ID = item.id;
      this.naziv = item.name;
      this.maticni_broj = item.identityNumber;
      this.pib = item.taxNumber;
      this.drzava = item.country;
      this.grad = item.city;
      this.adresa = item.address;
      this.fiksni = item.phone;
      this.mobilni = item.mobile;
      this.faks = item.fax;
      this.email = item.email;
      this.racun = item.bankAccount;
      this.banka = item.bankName;

      this.opis = item.description;
      this.postanski_broj = item.postalCode;
    });
  },
};
</script>

<style lang="scss" scoped>
// .currencyItemComponentForm {
//   max-width: 430px;
// }

.Description textarea {
  height: 40px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
</style>
